(function() {
  'use strict';
  
  let isInitialized = false;
  let isProcessingRequest = false;
  let processedRequests = new Set();
  let allSizeVariants = [];
  let sizeVariantStocks = {};
  let sizeDistribution = {};
  let minStockQuantity = 0;
  let availableSizes = [];
  let internalRequestFlag = 'SET_MULTIPLIER_INTERNAL_REQUEST';
  
  // ✅ YENİ: Aktif variant ve option bilgileri
  let currentSelectedVariant = null;
  let productVariants = [];
  let colorOptionPosition = 0;
  let groupOptionPosition = 0; // ✅ YENİ: Grup option pozisyonu
  let sizeOptionPosition = 0;  // ✅ YENİ: Beden option pozisyonu
  let requestVariantId = null; // ✅ YENİ: Request'ten gelen variant ID

  // ✅ KAT SAYI: İç giyim için kat sayı mantığı
  let katSayi = 0;
  let isKatSayiMode = false;
  let setInfoFound = false; // Set modu için flag
  
  const PRODUCTION_MODE = false;
  
  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Set Multiplier]', ...args);
    }
  }
  
  function logError(...args) {
    console.error('[Set Multiplier Error]', ...args);
  }

  // ✅ BİLDİRİM SİSTEMİ - Basit ve etkili
  function showSuccessNotification(message) {
    // Mevcut bildirimi kaldır
    const existing = document.querySelector('.success-notification');
    if (existing) existing.remove();
    
    // Yeni bildirim oluştur
    const notification = document.createElement('div');
    notification.className = 'success-notification';
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: linear-gradient(135deg, #28a745, #20c997);
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(40, 167, 69, 0.3);
      z-index: 99999;
      font-size: 14px;
      font-weight: 500;
      max-width: 350px;
      animation: slideInFromRight 0.4s ease-out;
      display: flex;
      align-items: center;
      gap: 10px;
    `;
    
    notification.innerHTML = `
      <span style="font-size: 18px;">✅</span>
      <span>${message}</span>
    `;
    
    // Sayfaya ekle
    document.body.appendChild(notification);
    
    // 3 saniye sonra kaldır
    setTimeout(() => {
      notification.style.animation = 'slideOutToRight 0.4s ease-in';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 400);
    }, 3000);
  }

  // ✅ BİLDİRİM ANIMASYONLARI - Minimal CSS
  function addNotificationStyles() {
    if (document.querySelector('#success-notification-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'success-notification-styles';
    style.textContent = `
      @keyframes slideInFromRight {
        from { 
          transform: translateX(100%);
          opacity: 0;
        }
        to { 
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes slideOutToRight {
        from { 
          transform: translateX(0);
          opacity: 1;
        }
        to { 
          transform: translateX(100%);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // ✅ YENİ: Tüm option pozisyonlarını bul
  function findOptionPositions() {
    if (!window.productVariantInfo || !window.productVariantInfo.allOptions) {
      log('Using fallback option detection');
      // Fallback: Liquid'den gelen pozisyonları kullan
      colorOptionPosition = window.productVariantInfo?.colorOptionPosition || 0;
      sizeOptionPosition = window.productVariantInfo?.sizeOptionPosition || 0;
      groupOptionPosition = findGroupOptionPositionFallback();
      return;
    }
    
    const options = window.productVariantInfo.allOptions;
    colorOptionPosition = 0;
    sizeOptionPosition = 0;
    groupOptionPosition = 0;
    
    for (let i = 0; i < options.length; i++) {
      const optionName = options[i].name.toLowerCase();
      
      // Renk option pozisyonu
      if ((optionName.includes('color') || optionName.includes('colour') || 
          optionName.includes('renk') || optionName === 'renk') && !colorOptionPosition) {
        colorOptionPosition = i + 1; // Shopify 1-indexed
      }
      
      // Beden option pozisyonu
      if ((optionName.includes('size') || optionName.includes('beden') || 
          optionName.includes('boyut') || optionName === 'size' || optionName === 'beden') && !sizeOptionPosition) {
        sizeOptionPosition = i + 1;
      }
      
      // ✅ YENİ: Grup option pozisyonu
      if ((optionName.includes('grup') || optionName.includes('group') || 
          optionName.includes('fiyat') || optionName.includes('price')) && !groupOptionPosition) {
        groupOptionPosition = i + 1;
      }
    }
    
    log('Option positions found:', {
      color: colorOptionPosition,
      size: sizeOptionPosition,
      group: groupOptionPosition
    });
  }

  // ✅ YENİ: Grup option pozisyonu fallback
  function findGroupOptionPositionFallback() {
    // DOM'dan grup seçicilerini ara
    const groupInputs = document.querySelectorAll('input[name*="Grup"], input[name*="Fiyat"], input[name*="Group"]');
    if (groupInputs.length > 0) {
      // Grup inputlarından birinin data-option-position değerini bul
      for (const input of groupInputs) {
        const optionPosition = input.getAttribute('data-option-position');
        if (optionPosition) {
          return parseInt(optionPosition);
        }
        
        // Alternatif: parent fieldset'in option pozisyonunu bul
        const fieldset = input.closest('fieldset, .wt-product__option');
        if (fieldset) {
          const legend = fieldset.querySelector('legend, .wt-product__option__title');
          if (legend && legend.textContent.toLowerCase().includes('grup')) {
            // Bu fieldset'in sırasını bul
            const allFieldsets = document.querySelectorAll('fieldset, .wt-product__option');
            for (let i = 0; i < allFieldsets.length; i++) {
              if (allFieldsets[i] === fieldset) {
                return i + 1;
              }
            }
          }
        }
      }
    }
    
    return 0;
  }

  // ✅ YENİ: Aktif seçilen variant'ı tespit et
  function getCurrentSelectedVariant() {
    // Shopify variant selector'dan seçilen variant'ı al
    const variantSelectors = [
      'input[name="id"]:checked',
      'select[name="id"]', 
      '[data-variant-id]',
      '.product-form__input input:checked',
      '.variant-input:checked'
    ];
    
    for (const selector of variantSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        const variantId = element.value || element.dataset.variantId;
        if (variantId) {
          const variant = productVariants.find(v => String(v.id) === String(variantId));
          if (variant) {
            log('Found selected variant:', variant);
            return variant;
          }
        }
      }
    }
    
    // Option seçicilerinden variant oluştur
    const optionValues = [];
    for (let i = 1; i <= 3; i++) {
      const optionSelector = `[data-option-position="${i}"]`;
      const selected = document.querySelector(`${optionSelector} input:checked, ${optionSelector} select`);
      if (selected) {
        optionValues.push(selected.value);
      }
    }
    
    if (optionValues.length > 0) {
      const variant = productVariants.find(v => {
        return optionValues.every((value, index) => {
          const optionKey = `option${index + 1}`;
          return v[optionKey] === value;
        });
      });
      
      if (variant) {
        log('Found variant by options:', variant);
        return variant;
      }
    }
    
    // Fallback: İlk available variant
    const firstAvailable = productVariants.find(v => v.available);
    if (firstAvailable) {
      log('Using first available variant:', firstAvailable);
      return firstAvailable;
    }
    
    return null;
  }

  // ✅ GÜNCELLENDİ: Seçilen tüm optionları koruyarak variant bul
  function findVariantIdBySize(targetSize) {
    const normalizedTarget = normalizeSize(targetSize);

    // ✅ YENİ: Önce request'ten gelen variant ID'yi kontrol et
    if (requestVariantId) {
      const requestVariant = productVariants.find(v => String(v.id) === requestVariantId);
      if (requestVariant) {
        log(`Using request variant for options: ${requestVariantId} (${requestVariant.title})`);
        currentSelectedVariant = requestVariant;
      } else {
        log(`Request variant ${requestVariantId} not found, falling back to DOM`);
        currentSelectedVariant = getCurrentSelectedVariant();
      }
    } else {
      currentSelectedVariant = getCurrentSelectedVariant();
    }

    if (!currentSelectedVariant) {
      log('No current variant selected, falling back to original method');
      return findVariantIdBySizeOriginal(targetSize);
    }
    
    // ✅ YENİ: Seçilen tüm optionları al (grup, renk vs.)
    const preservedOptions = {};
    
    // Renk seçimini koru
    if (colorOptionPosition > 0) {
      preservedOptions[`option${colorOptionPosition}`] = currentSelectedVariant[`option${colorOptionPosition}`];
    }
    
    // ✅ YENİ: Grup seçimini koru
    if (groupOptionPosition > 0) {
      preservedOptions[`option${groupOptionPosition}`] = currentSelectedVariant[`option${groupOptionPosition}`];
    }
    
    // Diğer sabit optionları da koru (beden hariç)
    for (let i = 1; i <= 3; i++) {
      if (i !== sizeOptionPosition && i !== colorOptionPosition && i !== groupOptionPosition) {
        const optionKey = `option${i}`;
        if (currentSelectedVariant[optionKey]) {
          preservedOptions[optionKey] = currentSelectedVariant[optionKey];
        }
      }
    }
    
    log(`Looking for variant: size=${targetSize}, preservedOptions=`, preservedOptions);
    
    // ✅ YENİ: Beden aralığı formatını kontrol et (3-4, 5-6, 7-8 gibi)
    const isRangeFormat = /^\d+-\d+$/.test(targetSize);
    
    // Tüm korunacak optionları içeren variant'ları içinden ara
    const matchingVariants = productVariants.filter(variant => {
      // Korunacak optionları kontrol et
      for (const [optionKey, optionValue] of Object.entries(preservedOptions)) {
        if (variant[optionKey] !== optionValue) {
          return false;
        }
      }
      
      // Size eşleşmesi kontrolü
      const variantTitle = variant.title || '';
      const option1 = variant.option1 || '';
      const option2 = variant.option2 || '';
      const option3 = variant.option3 || '';
      
      if (isRangeFormat) {
        // ✅ YENİ: Beden aralığı için özel mantık
        const rangeParts = targetSize.split('-');
        const startSize = rangeParts[0];
        const endSize = rangeParts[1];
        
        // Variant'ta bu aralıktaki bedenlerden birini arıyoruz
        return [variantTitle, option1, option2, option3].some(opt => {
          const optNormalized = normalizeSize(opt);
          // Tam sayı bedenleri için aralık kontrolü
          if (/^\d+$/.test(startSize) && /^\d+$/.test(endSize)) {
            const start = parseInt(startSize);
            const end = parseInt(endSize);
            const optNum = parseInt(optNormalized);
            if (!isNaN(optNum) && optNum >= start && optNum <= end) {
              return true;
            }
          }
          // Direk string eşleşmesi de kontrol et
          return optNormalized === normalizedTarget || 
                 optNormalized.includes(startSize) || 
                 optNormalized.includes(endSize);
        });
      } else {
        // Normal beden eşleşmesi
        return [variantTitle, option1, option2, option3].some(opt => 
          normalizeSize(opt) === normalizedTarget
        );
      }
    });
    
    if (matchingVariants.length > 0) {
      const foundVariant = matchingVariants.find(v => v.available) || matchingVariants[0];
      log(`Found variant with preserved options: ${foundVariant.id} (${foundVariant.title})`);
      return String(foundVariant.id);
    }
    
    log(`No variant found for size ${targetSize} with preserved options`, preservedOptions);
    return null;
  }

  // ✅ YENİ: Orijinal variant bulma metodu (fallback)
  function findVariantIdBySizeOriginal(targetSize) {
    const normalizedTarget = normalizeSize(targetSize);
    
    // Önce exact match ara
    for (const variantId in sizeVariantStocks) {
      const sizeInfo = sizeVariantStocks[variantId];
      const sizeName = normalizeSize(sizeInfo.sizeName);
      if (sizeName === normalizedTarget) {
        log(`Found exact variant match: ${targetSize} -> ${variantId}`);
        return variantId;
      }
    }
    
    // Sonra available sizes ile indexe göre ara
    for (let i = 0; i < availableSizes.length; i++) {
      const availableSize = normalizeSize(availableSizes[i]);
      if (availableSize === normalizedTarget && i < allSizeVariants.length) {
        log(`Found indexed variant match: ${targetSize} -> ${allSizeVariants[i]}`);
        return allSizeVariants[i];
      }
    }
    
    log(`No variant found for size: ${targetSize}`);
    return null;
  }
  
  function initializeMultiplier() {
    if (!window.productVariantInfo) {
      logError('Product variant info not found');
      return false;
    }

    const info = window.productVariantInfo;
    allSizeVariants = info.allSizeVariantIds || [];
    minStockQuantity = info.minStockQuantity || 0;
    availableSizes = info.allSizes || [];

    // ✅ KAT SAYI: İç giyim kontrolü
    if (info.katSayiFound && info.katSayi > 0) {
      katSayi = info.katSayi;
      isKatSayiMode = true;
      setInfoFound = false;
      log('Kat Sayı modu aktif:', katSayi);
    } else {
      setInfoFound = info.setInfoFound || false;
    }

    // ✅ YENİ: Variant bilgilerini yükle
    if (window.product && window.product.variants) {
      productVariants = window.product.variants;
    } else if (info.productVariants) {
      productVariants = info.productVariants;
    }

    // ✅ YENİ: Tüm option pozisyonlarını bul
    findOptionPositions();

    log('Product info loaded:', info.productTitle);
    log('Option positions:', {
      color: colorOptionPosition,
      size: sizeOptionPosition,
      group: groupOptionPosition
    });
    log('Total variants:', productVariants.length);
    log('Mode:', isKatSayiMode ? `Kat Sayı (${katSayi})` : (setInfoFound ? 'Set' : 'Normal'));

    // Kat Sayı modunda set distribution gerekmez
    if (isKatSayiMode) {
      log('Kat Sayı modu - set distribution atlanıyor');
      setupKatSayiUI();
      setupVariantChangeListeners();
      return true;
    }

    if (allSizeVariants.length === 0) {
      logError('No size variants found');
      return false;
    }

    parseVariantStocks(info.sizeVariantStocks);
    sizeDistribution = parseSetDistribution(info.setDistribution || 'AUTO');

    if (Object.keys(sizeDistribution).length === 0) {
      logError('Could not parse size distribution');
      return false;
    }

    log('Set Multiplier initialized successfully');
    log('Size Distribution:', sizeDistribution);

    moveSetInfoToCorrectPosition();
    updateSetInfoDisplay();

    // ✅ YENİ: Variant değişikliklerini dinle
    setupVariantChangeListeners();

    return true;
  }

  // ✅ KAT SAYI: UI setup fonksiyonu
  function setupKatSayiUI() {
    // Kat Sayı bilgi paneli oluştur
    const priceSelectors = [
      '.price:not(.price--sold-out)',
      '.product-price',
      '.product__price',
      '.product-form__price',
      '[data-price]'
    ];

    let priceElement = null;
    for (const selector of priceSelectors) {
      priceElement = document.querySelector(selector);
      if (priceElement) break;
    }

    if (priceElement) {
      const katSayiInfo = document.createElement('div');
      katSayiInfo.id = 'katSayiInfo';
      katSayiInfo.style.cssText = `
        margin-top: 15px;
        padding: 12px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border-radius: 8px;
        font-size: 14px;
        line-height: 1.4;
      `;
      katSayiInfo.innerHTML = `
        <strong>📦 Kat Sayı:</strong> ${katSayi}
        <div style="margin-top: 6px; font-size: 13px; opacity: 0.9;">
          Bu ürün <strong>${katSayi}'er ${katSayi}'er</strong> sepete eklenir.
        </div>
      `;
      priceElement.parentNode.insertBefore(katSayiInfo, priceElement.nextSibling);
    }

    // Quantity input'u Kat Sayı'nın katlarına ayarla
    setupKatSayiQuantityInput();
  }

  // ✅ KAT SAYI: Quantity input setup
  function setupKatSayiQuantityInput() {
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (!quantityInput) return;

    // Minimum değeri kat sayıya ayarla
    quantityInput.min = katSayi;
    quantityInput.step = katSayi;
    quantityInput.value = katSayi;

    // Input değişikliğini dinle ve kat sayının katına yuvarla
    quantityInput.addEventListener('change', (e) => {
      let value = parseInt(e.target.value) || katSayi;
      // En yakın kat sayıya yuvarla
      value = Math.ceil(value / katSayi) * katSayi;
      e.target.value = value;
    });

    // Plus/minus butonlarını güncelle
    const plusBtn = document.querySelector('[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"]');
    const minusBtn = document.querySelector('[name="minus"], .quantity__button[name="minus"], button[aria-label*="Decrease"]');

    if (plusBtn) {
      const newPlusBtn = plusBtn.cloneNode(true);
      plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
      newPlusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(quantityInput.value) || katSayi;
        quantityInput.value = current + katSayi;
        quantityInput.dispatchEvent(new Event('change'));
      });
    }

    if (minusBtn) {
      const newMinusBtn = minusBtn.cloneNode(true);
      minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
      newMinusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(quantityInput.value) || katSayi;
        const newValue = Math.max(katSayi, current - katSayi);
        quantityInput.value = newValue;
        quantityInput.dispatchEvent(new Event('change'));
      });
    }
  }

  // ✅ YENİ: Variant değişiklik dinleyicileri
  function setupVariantChangeListeners() {
    // Variant selector değişikliklerini dinle
    const variantSelectors = [
      'input[name="id"]',
      'select[name="id"]',
      '[data-option-position] input',
      '[data-option-position] select',
      '.variant-input',
      '.product-form__input input'
    ];
    
    variantSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        ['change', 'click', 'input'].forEach(eventType => {
          element.addEventListener(eventType, () => {
            setTimeout(() => {
              currentSelectedVariant = getCurrentSelectedVariant();
              log('Variant changed:', currentSelectedVariant);
              updateSetInfoDisplay();
            }, 100);
          });
        });
      });
    });
    
    // Shopify variant selector events
    document.addEventListener('variant:change', (e) => {
      setTimeout(() => {
        currentSelectedVariant = e.detail || getCurrentSelectedVariant();
        log('Shopify variant change event:', currentSelectedVariant);
      }, 100);
    });
  }
  
  function parseVariantStocks(stockString) {
    if (!stockString) return;
    
    const stockPairs = stockString.split(',');
    stockPairs.forEach(pair => {
      const parts = pair.split(':');
      if (parts.length === 2) {
        const variantId = parts[0];
        const stockAndSize = parts[1].split('|');
        
        if (stockAndSize.length === 2) {
          const stock = parseInt(stockAndSize[0]) || 0;
          const sizeName = stockAndSize[1];
          sizeVariantStocks[variantId] = { stock, sizeName };
        }
      }
    });
  }
  
  // ✅ YENİ: Set İçeriği formatı için özel parser
  function parseSetIcerigiFormat(distributionText) {
    if (!distributionText) return {};

    const distribution = {};
    let text = distributionText.toString().trim();

    // Set İçeriği formatı için özel temizleme
    text = text.replace(/<[^>]*>/g, ' '); // HTML tags'leri boşlukla değiştir
    text = text.replace(/&[a-zA-Z0-9#]+;/g, ' ');
    text = text.replace(/[\r\n\t\f\v]/g, ' ');
    text = text.replace(/\s+/g, ' ');
    text = text.trim();

    log('Parsing Set İçeriği format:', text);

    // Set İçeriği formatına özel invalid words
    const invalidWords = new Set(['ÖLÇÜ', 'TABLOSU', 'CM', 'BOYUT', 'GENİŞLİĞİ', 'UZUNLUĞU', 'DÜŞÜKLÜĞÜ', 'WIDTH', 'LENGTH', 'DROP', 'CHEST', 'BACK', 'SLEEVE', 'NECK', 'SHOULDER']);

    // İlk önce invalid kelimelerden sonrasını kes
    for (const invalidWord of invalidWords) {
      if (text.toUpperCase().includes(invalidWord)) {
        const parts = text.toUpperCase().split(invalidWord);
        text = parts[0].trim();
        break;
      }
    }

    log('Cleaned text for Set İçeriği:', text);

    // Bilinen bedenler (uzundan kısaya sıralı)
    const knownSizes = ['XXXL', 'XXL', 'XXS', '4XL', '3XL', '2XL', '2XS', 'XL', 'XS', 'S', 'M', 'L'];

    // ✅ KZK FORMAT: S-M=1|L-XL=1|7-8 Yas=2 (her seyi destekler, en oncelikli)
    // Pipe ile ayrilmis BEDEN=ADET ciftleri
    if (text.includes('=') && text.includes('|')) {
      const kzkPairs = text.split('|').map(s => s.trim()).filter(Boolean);
      let kzkMatched = false;
      for (const pair of kzkPairs) {
        const eqIdx = pair.lastIndexOf('=');
        if (eqIdx > 0) {
          const size = pair.substring(0, eqIdx).trim().toUpperCase();
          const qty = parseInt(pair.substring(eqIdx + 1).trim(), 10);
          if (size && !isNaN(qty) && qty > 0) {
            distribution[size] = qty;
            kzkMatched = true;
            log(`Added KZK item: ${size} = ${qty}`);
          }
        }
      }
      if (kzkMatched && Object.keys(distribution).length > 0) {
        return distribution;
      }
    }

    // ✅ YENİ FORMAT: L-2 XL-4 2XL-4 3XL-2 (beden-adet tire ile ayrılmış)
    // Pattern: (opsiyonel numara + harf beden) + tire + adet
    const hyphenatedMatches = [...text.matchAll(/\b(\d*[SMLX]{1,3}L?)\s*-\s*(\d+)\b/gi)];
    if (hyphenatedMatches.length > 0) {
      log(`Found hyphenated format matches (L-2, XL-4...): ${hyphenatedMatches.length}`);

      for (const match of hyphenatedMatches) {
        const size = match[1].toUpperCase();
        const quantity = match[2];

        // Geçerli beden olduğundan emin ol
        const isValidSize = knownSizes.includes(size) || /^\d*[SMLX]{1,3}L?$/i.test(size);
        const q = parseInt(quantity, 10);
        if (isValidSize && !isNaN(q) && q > 0) {
          distribution[size] = q;
          log(`Added hyphenated item: ${size} = ${q}`);
        }
      }

      if (Object.keys(distribution).length > 0) {
        return distribution;
      }
    }

    // ✅ YENİ FORMAT: 1XL1-2XL1-3XL1-4XL1 (BedenNumara formatı)
    const complexMatches = [...text.matchAll(/(\d+)([A-Z]{1,3})(\d+)/gi)];
    if (complexMatches.length > 0) {
      log(`Found complex format matches (1XL1...): ${complexMatches.length}`);

      for (const match of complexMatches) {
        const fullSizeName = match[1] + match[2].toUpperCase();
        const quantity = parseInt(match[3], 10);
        if (!isNaN(quantity) && quantity > 0) {
          distribution[fullSizeName] = quantity;
          log(`Added complex item: ${fullSizeName} = ${quantity}`);
        }
      }

      if (Object.keys(distribution).length > 0) {
        return distribution;
      }
    }

    // ✅ YENİ FORMAT: S1-M1-L1-XL1 (Standart beden+adet bitişik)
    const escapedSizes = knownSizes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const sizePattern = new RegExp(`(${escapedSizes.join('|')})(\\d+)`, 'gi');
    const standardMatches = [...text.matchAll(sizePattern)];
    if (standardMatches.length > 0) {
      log(`Found standard format matches (S1-M1...): ${standardMatches.length}`);

      for (const match of standardMatches) {
        const size = match[1].toUpperCase();
        const quantity = parseInt(match[2], 10);
        if (!isNaN(quantity) && quantity > 0) {
          distribution[size] = quantity;
          log(`Added standard item: ${size} = ${quantity}`);
        }
      }

      if (Object.keys(distribution).length > 0) {
        return distribution;
      }
    }

    // Set İçeriği formatına özel pattern: digit-digit-digit formatı
    const setIcerigiMatches = [...text.matchAll(/(\d+-\d+)-(\d+)/g)];

    if (setIcerigiMatches.length > 0) {
      log(`Found Set İçeriği format matches: ${setIcerigiMatches.length}`);

      for (const match of setIcerigiMatches) {
        const sizeRange = match[1]; // "7-8", "9-10", etc.
        const quantity = match[2];   // "1", "1", etc.

        const q = parseInt(quantity, 10);
        if (!isNaN(q) && q > 0) {
          distribution[sizeRange] = q;
          log(`Added Set İçeriği item: ${sizeRange} = ${q}`);
        }
      }

      return distribution;
    }

    // Eğer digit-digit-digit formatı bulunamazsa, boşlukla ayrılmış aralıkları dene
    const spaceMatches = [...text.matchAll(/(\d+-\d+)/g)];
    if (spaceMatches.length > 0) {
      log(`Found space-separated ranges: ${spaceMatches.length}`);

      for (const match of spaceMatches) {
        const sizeRange = match[1];
        distribution[sizeRange] = 1; // Default quantity
        log(`Added space-separated range: ${sizeRange} = 1`);
      }

      return distribution;
    }

    log('No Set İçeriği format matches found');
    return {};
  }
  
  /** '85=2|90=2|95=1|100=1' -> { '85':2, ... }  Sayisal bedenlerde eski parser calismiyor. */
  function parseBedenAdetCiftleri(text) {
    if (!text) return null;
    const dagilim = {};
    let sayi = 0;
    String(text).split('|').forEach(par => {
      const k = par.trim().match(/^([^=\s]+)\s*=\s*(\d+)$/);
      if (k && parseInt(k[2], 10) > 0) { dagilim[k[1]] = parseInt(k[2], 10); sayi++; }
    });
    return sayi >= 2 ? dagilim : null;
  }

  function parseSetDistribution(distributionText) {
    const ciftler = parseBedenAdetCiftleri(distributionText);
    if (ciftler) return ciftler;

    if (!distributionText) return {};
    
    const distribution = {};
    let text = distributionText.toString().trim();
     if (text.includes('Set İçeriği:') || /\d+-\d+-\d+/.test(text)) {
    log('Detected Set İçeriği format, using special parser');
    const setIcerigiResult = parseSetIcerigiFormat(text);
    if (Object.keys(setIcerigiResult).length > 0) {
      return setIcerigiResult;
    }
    log('Set İçeriği parser failed, continuing with normal parsing');
  }
    // HTML ve özel karakterleri temizle
    text = text.replace(/<[^>]*>/g, '');
    text = text.replace(/&[a-zA-Z0-9#]+;/g, '');
    text = text.replace(/[*]/g, '');
    text = text.replace(/[\r\n\t\f\v]/g, ' ');
    text = text.replace(/\s+/g, ' ');
    text = text.trim();
    
    log('Parsing distribution text:', text);
    
    const invalid = new Set(['TRY','USD','EUR','GBP','ADET','KG','TL','CM','MM','PIECE']);
    const sizesSrc = Array.isArray(availableSizes) && availableSizes.length ? availableSizes : 
                    (window.productVariantInfo && Array.isArray(window.productVariantInfo.allSizes) ? window.productVariantInfo.allSizes : []);
    const knownSizes = Array.from(new Set(sizesSrc.map(s => String(s).toUpperCase().trim()).filter(Boolean)));
    knownSizes.sort((a,b) => b.length - a.length); // Önce uzun bedenleri kontrol et (XXL vs XL)
    
    const addToDistribution = (size, qty) => {
      const s = String(size).toUpperCase().trim();
      const q = parseInt(qty, 10);
      if (!s || isNaN(q) || q <= 0 || invalid.has(s)) return false;
      
      // Eğer bu beden zaten eklenmiş́se, sadece ilk değeri tut (çiftleme engelle)
      if (distribution[s]) {
        log(`Size ${s} already exists with quantity ${distribution[s]}, skipping duplicate`);
        return false;
      }
      
      distribution[s] = q;
      log(`Added to distribution: ${s} = ${q}`);
      return true;
    };
    
    let matched = false;
    
    // ✅ YENİ FORMAT 1: Beden aralığı + miktar (3-4-1, 5-6-1, 7-8-2)
    // Daha kesin pattern: kelime sınırları ve boşluk kontrolü ile
    const rangeWithQuantityMatches = [...text.matchAll(/(?:^|\s)(\d+-\d+)-(\d+)(?=\s|$)/g)];
    if (rangeWithQuantityMatches.length > 0) {
      log(`Found range+quantity format matches: ${rangeWithQuantityMatches.length}`);
      
      for (const match of rangeWithQuantityMatches) {
        const sizeRange = match[1]; // "3-4", "5-6", "7-8"
        const quantity = match[2];   // "1", "1", "2"
        
        log(`Processing range+quantity: ${sizeRange} -> ${quantity}`);
        if (addToDistribution(sizeRange, quantity)) {
          matched = true;
        }
      }
    }
    
    // ✅ YENİ FORMAT 2: Sadece beden aralığı (9-10, 11-12, 13-14) - miktar 1 varsayılır
    if (!matched) {
      // Daha kesin pattern: sadece "sayı-sayı" formatı, etrafında boşluk olmalı
      const rangeOnlyMatches = [...text.matchAll(/(?:^|\s)(\d+-\d+)(?=\s|$)/g)];
      if (rangeOnlyMatches.length > 0) {
        log(`Found range-only format matches: ${rangeOnlyMatches.length}`);
        
        for (const match of rangeOnlyMatches) {
          const sizeRange = match[1]; // "9-10", "11-12", "13-14"
          
          log(`Processing range-only: ${sizeRange} -> 1`);
          if (addToDistribution(sizeRange, 1)) {
            matched = true;
          }
        }
      }
    }
    
    // FORMAT 3: 1XL1-2XL2-3XL1-4XL1 (BedenNumara formatı) - sadece önceki formatlar başarısız olursa
    if (!matched) {
      const complexMatches = [...text.matchAll(/(\d+)([A-Z]{1,3})(\d+)/g)];
      if (complexMatches.length > 0) {
        log(`Found complex format matches: ${complexMatches.length}`);
        
        for (const match of complexMatches) {
          const prefix = match[1]; // İlk rakam (beden numarası)
          const sizeBase = match[2]; // Beden harfleri (XL, L, vb.)
          const quantity = match[3]; // Adet
          
          // Tam beden adını oluştur (1XL, 2XL, vb.)
          const fullSizeName = prefix + sizeBase;
          
          if (addToDistribution(fullSizeName, quantity)) {
            matched = true;
          }
        }
      }
    }
    
    // FORMAT 4: XL1-L2-M1 (Standart beden+adet formatı) - sadece önceki formatlar başarısız olursa
    if (!matched && knownSizes.length > 0) {
      const escapedSizes = knownSizes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      const sizePattern = new RegExp(`(${escapedSizes.join('|')})(\\d+)`, 'g');
      const sizeMatches = [...text.matchAll(sizePattern)];
      
      for (const match of sizeMatches) {
        const size = match[1];
        const quantity = match[2];
        
        if (addToDistribution(size, quantity)) {
          matched = true;
        }
      }
    }
    
    // FORMAT 5: S-M-L-XL (Adet belirtilmemiş, her bedenden 1'er adet) - sadece önceki formatlar başarısız olursa
    if (!matched) {
      // Tire ile ayrılmış formatı kontrol et
      const dashSeparated = text.split(/[-\s,|\/]+/).filter(part => {
        const cleaned = part.trim().toUpperCase();
        return cleaned.length > 0 && 
               !invalid.has(cleaned) && 
               /^[A-Z0-9]+$/.test(cleaned) &&
               !(/^\d+$/.test(cleaned) && cleaned.length > 2); // Sadece sayı olan uzun değerleri hariç tut
      });
      
      if (dashSeparated.length > 1) {
        log('Found dash-separated format:', dashSeparated);
        for (const part of dashSeparated) {
          const cleanPart = part.trim().toUpperCase();
          
          // Bilinen bedenler listesinde varsa veya tipik beden formatındaysa
          if (knownSizes.includes(cleanPart) || 
              /^(XXS|XS|S|M|L|XL|XXL|XXXL|\d+XL|\d+L|2XS|3XL|4XL)$/i.test(cleanPart)) {
            if (addToDistribution(cleanPart, 1)) {
              matched = true;
            }
          }
        }
      }
    }
    
    // FORMAT 6: L-2 XL-4 2XL-4 3XL-2 (beden-adet tire ile ayrılmış)
    if (!matched) {
      const defaultSizes = ['XXXL', 'XXL', 'XXS', '4XL', '3XL', '2XL', '2XS', 'XL', 'XS', 'S', 'M', 'L'];
      const hyphenatedMatches = [...text.matchAll(/\b(\d*[SMLX]{1,3}L?)\s*-\s*(\d+)\b/gi)];
      if (hyphenatedMatches.length > 0) {
        log(`Found hyphenated format matches (L-2, XL-4...): ${hyphenatedMatches.length}`);
        for (const match of hyphenatedMatches) {
          const size = match[1].toUpperCase();
          const quantity = match[2];
          const isValidSize = defaultSizes.includes(size) || /^\d*[SMLX]{1,3}L?$/i.test(size);
          if (isValidSize && !invalid.has(size) && addToDistribution(size, quantity)) {
            matched = true;
          }
        }
      }
    }

    // FORMAT 7: Alternatif format arama - S:2, M:1 gibi kolon formatı - sadece önceki formatlar başarısız olursa
    if (!matched) {
      const colonMatches = [...text.matchAll(/([A-Z0-9]{1,4})\s*:\s*(\d+)/gi)];

      for (const match of colonMatches) {
        const size = match[1].toUpperCase();
        const quantity = match[2];

        if (!invalid.has(size) && addToDistribution(size, quantity)) {
          matched = true;
        }
      }
    }

    // FORMAT 8: Eğer hiçbir format eşleşmezse ve bilinen bedenler varsa, hepsinden 1'er adet
    if (!matched && knownSizes.length > 0) {
      log('No specific format found, using all available sizes with quantity 1');
      for (const size of knownSizes) {
        if (!invalid.has(size)) {
          addToDistribution(size, 1);
          matched = true;
        }
      }
    }
    
    log('Final distribution:', distribution);
    return distribution;
  }

  function moveSetInfoToCorrectPosition() {
    const setInfoElement = document.getElementById('setMultiplierInfo');
    if (!setInfoElement) {
      log('Set info element not found, will be created later');
      return;
    }
    
    const priceSelectors = [
      '.price:not(.price--sold-out)',
      '.product-price',
      '.product__price', 
      '.product-form__price',
      '[data-price]',
      '[data-product-price]',
      '.money',
      '.price-item',
      '.price-wrapper',
      '.product-price-wrapper'
    ];
    
    let priceElement = null;
    
    for (const selector of priceSelectors) {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        priceElement = Array.from(elements).find(el => {
          const rect = el.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        });
        if (priceElement) {
          log(`Found price element with selector: ${selector}`);
          break;
        }
      }
    }
    
    if (!priceElement) {
      const productForm = document.querySelector('form[action*="/cart/add"], .product-form');
      if (productForm) {
        priceElement = productForm.querySelector('.price, [class*="price"]');
        if (priceElement) {
          log('Found price element in product form');
        }
      }
    }
    
    if (priceElement) {
      priceElement.parentNode.insertBefore(setInfoElement, priceElement.nextSibling);
      log('Set info moved to position after price element');
    } else {
      log('Price element not found, keeping set info in original position');
      const productForm = document.querySelector('form[action*="/cart/add"], .product-form');
      if (productForm) {
        productForm.appendChild(setInfoElement);
        log('Set info moved to end of product form');
      }
    }
  }
  
  function updateSetInfoDisplay() {
    const setInfoText = document.getElementById('setInfoText');
    const setInfoDetails = document.getElementById('setInfoDetails');
    
    if (!setInfoText || !setInfoDetails) return;
    
    const totalItems = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);
    
    setInfoText.innerHTML = `<strong>Set Ürün:</strong> Her 1 adet için ${totalItems} farklı beden/numara ürününü sepetinize eklenecektir.`;
    
    let detailsHtml = '<div style="margin-top: 5px;"><strong>Dağılım:</strong> ';
    const distributionParts = [];
    for (const [size, qty] of Object.entries(sizeDistribution)) {
      distributionParts.push(`${size} (${qty} adet)`);
    }
    detailsHtml += distributionParts.join(', ') + '</div>';
    setInfoDetails.innerHTML = detailsHtml;
  }
  
  function getCurrentQuantity() {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];
    
    for (const selector of quantitySelectors) {
      const input = document.querySelector(selector);
      if (input && input.value) {
        const value = parseInt(input.value) || 1;
        log(`Found quantity input: ${selector} = ${value}`);
        return Math.max(1, value);
      }
    }
    
    log('No quantity input found, defaulting to 1');
    return 1;
  }
  
  function updateSetInfoOnQuantityChange(quantity) {
    const setInfoDetails = document.getElementById('setInfoDetails');
    if (!setInfoDetails) return;
    
    quantity = Math.max(1, parseInt(quantity) || 1);
    
    const totalPerSet = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);
    const finalTotal = quantity * totalPerSet;
    
    let detailsHtml = `<div style="margin-top: 5px; padding: 8px; background: #e8f4f8; border-radius: 4px; border: 1px solid #007cba;">
      <strong>Sepete eklenecek:</strong> ${quantity} set × ${totalPerSet} adet = <span style="color: #007cba; font-weight: bold;">${finalTotal} adet</span><br>
      <small style="color: #666;">Detay: `;
    
    const details = [];
    for (const [size, qty] of Object.entries(sizeDistribution)) {
      const sizeTotal = qty * quantity;
      details.push(`${size}: ${sizeTotal} adet`);
    }
    detailsHtml += details.join(', ') + '</small></div>';
    setInfoDetails.innerHTML = detailsHtml;
  }
  
  function setupQuantityListener() {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];
    
    quantitySelectors.forEach(selector => {
      const inputs = document.querySelectorAll(selector);
      inputs.forEach(input => {
        ['input', 'change', 'keyup', 'blur'].forEach(eventType => {
          input.addEventListener(eventType, (e) => {
            const quantity = parseInt(e.target.value) || 1;
            log(`Quantity changed via ${eventType}: ${quantity}`);
            updateSetInfoOnQuantityChange(quantity);
          });
        });
      });
    });
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              const quantityInputs = node.querySelectorAll ? node.querySelectorAll(quantitySelectors.join(',')) : [];
              quantityInputs.forEach(input => {
                ['input', 'change'].forEach(eventType => {
                  input.addEventListener(eventType, (e) => {
                    const quantity = parseInt(e.target.value) || 1;
                    updateSetInfoOnQuantityChange(quantity);
                  });
                });
              });
            }
          });
        }
      });
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }
  
  function normalizeSize(size) {
    return size.toString().toUpperCase().trim();
  }
  
  function forceMultiplier() {
    if (isInitialized) return;
    isInitialized = true;

    // ✅ BİLDİRİM STİLLERİNİ EKLE
    addNotificationStyles();
    
    if (!initializeMultiplier()) {
      logError('Set multiplier initialization failed');
      return;
    }
    
    const originalFetch = window.fetch;
    let interceptorApplied = false;
    
    if (!interceptorApplied) {
      window.fetch = async function(url, options = {}) {
        if (options.headers && options.headers[internalRequestFlag]) {
          delete options.headers[internalRequestFlag];
          return originalFetch.call(this, url, options);
        }

        if (typeof url === 'string' && url.includes('/cart/add')) {
          // ✅ YENİ: Quickview veya çoklu ürün ekleme için items array kontrolü
          // Quickview {items: [...]} formatı kullanır, bunu yakalamamalıyız
          try {
            let bodyData = null;
            if (typeof options.body === 'string') {
              bodyData = JSON.parse(options.body);
            }

            // items array varsa quickview veya başka bir multi-item request
            // Bu durumda set çarpımı uygulamadan direkt geç
            if (bodyData && Array.isArray(bodyData.items)) {
              log('Skipping set multiplier - items array detected (quickview request)');
              return originalFetch.call(this, url, options);
            }
          } catch (e) {
            // JSON parse hatası - normal devam et
          }

          // ✅ KAT SAYI: Kat Sayı modunda farklı işlem
          if (isKatSayiMode) {
            log('Kat Sayı modu - direkt ekleme (miktar zaten ayarlandı)');
            // Kat Sayı modunda miktar zaten input'ta ayarlandı, direkt ekle
            return handleKatSayiCartRequest(originalFetch, url, options);
          }

          // Set modu
          if (setInfoFound) {
            return handleSetCartRequest(originalFetch, url, options);
          }

          // Normal mod - direkt geç
          return originalFetch.call(this, url, options);
        }

        return originalFetch.call(this, url, options);
      };
      interceptorApplied = true;
      log('Fetch interceptor applied');
    }
    
    setTimeout(() => {
      setupQuantityListener();
      moveSetInfoToCorrectPosition();
      const initialQuantity = getCurrentQuantity();
      log(`Updating with initial quantity: ${initialQuantity}`);
      updateSetInfoOnQuantityChange(initialQuantity);
    }, 500);
    
    log('Set Multiplier active');
  }

  // ✅ KAT SAYI: Kat Sayı modunda sepete ekleme
  async function handleKatSayiCartRequest(originalFetch, url, options) {
    const requestSignature = createRequestSignature(options.body);

    if (processedRequests.has(requestSignature)) {
      return new Response(JSON.stringify({
        status: 'success',
        message: 'Request already processed',
        duplicate: true
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    processedRequests.add(requestSignature);

    if (isProcessingRequest) {
      return new Response(JSON.stringify({
        status: 'success',
        message: 'İşleniyor...',
        processing: true
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    isProcessingRequest = true;

    try {
      let userQuantity = getQuantityFromData(options.body);

      // Miktarı Kat Sayının katına yuvarla
      userQuantity = Math.ceil(userQuantity / katSayi) * katSayi;

      log(`Kat Sayı modu: ${userQuantity} adet ekleniyor (${katSayi}'nin katı)`);

      // Miktarı güncelleyerek direkt ekle
      const newBody = createKatSayiRequestBody(options.body, userQuantity);
      const newOptions = {
        ...options,
        body: newBody,
        headers: {
          ...options.headers,
          [internalRequestFlag]: 'true'
        }
      };

      const response = await originalFetch.call(this, url, newOptions);

      if (response.ok) {
        showSuccessNotification(`${userQuantity} adet başarıyla sepete eklendi!`);
        setTimeout(() => updateCartCount(), 300);
      }

      return response;

    } catch (error) {
      logError('Kat Sayı request error:', error);
      return originalFetch.call(this, url, options);

    } finally {
      setTimeout(() => {
        isProcessingRequest = false;
        setTimeout(() => {
          processedRequests.delete(requestSignature);
        }, 10000);
      }, 2000);
    }
  }

  // ✅ KAT SAYI: Request body oluştur
  function createKatSayiRequestBody(originalBody, quantity) {
    if (originalBody instanceof FormData) {
      const newFormData = new FormData();
      for (let [key, value] of originalBody.entries()) {
        if (key === 'quantity') {
          newFormData.append(key, quantity);
        } else {
          newFormData.append(key, value);
        }
      }
      if (!newFormData.has('quantity')) {
        newFormData.append('quantity', quantity);
      }
      return newFormData;
    }

    if (typeof originalBody === 'string') {
      try {
        const json = JSON.parse(originalBody);
        json.quantity = quantity;
        return JSON.stringify(json);
      } catch (e) {
        let result = originalBody;
        result = result.replace(/quantity=([^&]+)/g, `quantity=${quantity}`);
        if (!result.includes('quantity=')) {
          result += (result.includes('?') ? '&' : '?') + `quantity=${quantity}`;
        }
        return result;
      }
    }

    return originalBody;
  }

  async function handleSetCartRequest(originalFetch, url, options) {
    const requestSignature = createRequestSignature(options.body);
    
    if (processedRequests.has(requestSignature)) {
      return new Response(JSON.stringify({
        status: 'success',
        message: 'Request already processed',
        duplicate: true
      }), { 
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }
    
    processedRequests.add(requestSignature);
    
    if (isProcessingRequest) {
      return new Response(JSON.stringify({
        status: 'success',
        message: 'Set işleniyor...',
        processing: true
      }), { 
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }
    
    isProcessingRequest = true;

    try {
      const userQuantity = getQuantityFromData(options.body);

      // ✅ YENİ: Request'ten gelen variant ID'sini sakla
      requestVariantId = getVariantIdFromData(options.body);
      if (requestVariantId) {
        const requestVariant = productVariants.find(v => String(v.id) === requestVariantId);
        if (requestVariant) {
          log(`Using variant from request: ${requestVariantId} (${requestVariant.title})`);
        } else {
          log(`Request variant ID ${requestVariantId} not found in productVariants`);
        }
      }

      log(`Processing set cart request for ${userQuantity} sets`);

      const addResults = await addTraditionalSetToCart(originalFetch, userQuantity, url, options);
      
      if (addResults.success) {
        log(`Set successfully added: ${addResults.totalAdded} total items`);
        
        // ✅ BAŞARILI BİLDİRİM GÖSTER
        const totalPerSet = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);
        const notificationMessage = `${userQuantity} set (${addResults.totalAdded} adet) başarıyla sepete eklendi!`;
        showSuccessNotification(notificationMessage);
        
        setTimeout(() => {
          triggerCartEvents({ item_count: addResults.totalAdded });
        }, 100);
        
        setTimeout(() => updateCartCount(), 300);
        
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.open();
          }
        }, 500);
        
        return new Response(JSON.stringify({
          status: 'success',
          message: `${userQuantity} set (${addResults.totalAdded} adet) ürün eklendi`,
          details: addResults.details,
          format: 'traditional',
          id: Date.now(),
          quantity: addResults.totalAdded,
          variant_id: 'multiple',
          line_price: 0,
          sections: {
            'cart-drawer': '<div>Updated cart content</div>',
            'cart-icon-bubble': `<span>${addResults.totalAdded}</span>`
          }
        }), { 
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        });
      } else {
        logError('Set adding failed:', addResults.errors);
        return originalFetch.call(this, url, options);
      }
      
    } catch (error) {
      logError('Set request error:', error);
      return originalFetch.call(this, url, options);
      
    } finally {
      // ✅ YENİ: Request variant ID'yi temizle
      requestVariantId = null;
      setTimeout(() => {
        isProcessingRequest = false;
        setTimeout(() => {
          processedRequests.delete(requestSignature);
        }, 10000);
      }, 2000);
    }
  }
  
  async function addTraditionalSetToCart(originalFetch, userQuantity, originalUrl, originalOptions) {
    const results = {
      success: true,
      errors: [],
      details: [],
      totalAdded: 0
    };
    
    log('Adding traditional set to cart:', sizeDistribution);
    
    for (const [size, baseQty] of Object.entries(sizeDistribution)) {
      const finalQty = baseQty * userQuantity;
      const variantId = findVariantIdBySize(size);
      
      log(`Processing size ${size}: baseQty=${baseQty}, userQty=${userQuantity}, finalQty=${finalQty}, variantId=${variantId}`);
      
      if (!variantId) {
        results.errors.push(`${size} bedeni/numarası bulunamadı`);
        log(`Variant not found for size: ${size}`);
        continue;
      }
      
      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
        results.errors.push(`${size} stok yetersiz: ${stockInfo.stock} < ${finalQty}`);
        log(`Insufficient stock for ${size}: ${stockInfo.stock} < ${finalQty}`);
        continue;
      }
      
      try {
        const newRequestBody = createSizeRequestBody(originalOptions.body, variantId, finalQty);
        
        const sizeOptions = { 
          ...originalOptions, 
          body: newRequestBody,
          headers: {
            ...originalOptions.headers,
            [internalRequestFlag]: 'true'
          }
        };
        
        log(`Adding ${size} to cart: variantId=${variantId}, qty=${finalQty}`);
        const response = await originalFetch.call(this, originalUrl, sizeOptions);
        
        if (response.ok) {
          results.details.push(`${size}: ${finalQty} adet`);
          results.totalAdded += finalQty;
          log(`Successfully added ${size}: ${finalQty} items`);
        } else {
          const errorText = await response.text();
          results.errors.push(`${size}: HTTP ${response.status}`);
          log(`Error adding ${size}: ${response.status} - ${errorText}`);
        }
        
        // Her request arasında kısa bekleme
        await new Promise(resolve => setTimeout(resolve, 300));
        
      } catch (error) {
        results.errors.push(`${size}: ${error.message}`);
        logError(`Exception adding ${size}:`, error);
      }
    }
    
    if (results.errors.length > 0) {
      results.success = false;
      log('Some errors occurred:', results.errors);
    }
    
    log('Final add results:', results);
    return results;
  }
  
  function createSizeRequestBody(originalBody, variantId, quantity) {
    if (originalBody instanceof FormData) {
      const newFormData = new FormData();
      for (let [key, value] of originalBody.entries()) {
        if (key === 'id' || key === 'variant_id') {
          newFormData.append(key, variantId);
        } else if (key === 'quantity') {
          newFormData.append(key, quantity);
        } else {
          newFormData.append(key, value);
        }
      }
      
      if (!newFormData.has('id')) {
        newFormData.append('id', variantId);
      }
      if (!newFormData.has('quantity')) {
        newFormData.append('quantity', quantity);
      }
      
      return newFormData;
    }
    
    if (typeof originalBody === 'string') {
      try {
        const json = JSON.parse(originalBody);
        json.id = variantId;
        json.quantity = quantity;
        return JSON.stringify(json);
      } catch (e) {
        let result = originalBody;
        result = result.replace(/[?&]id=([^&]+)/g, `id=${variantId}`);
        result = result.replace(/[?&]quantity=([^&]+)/g, `quantity=${quantity}`);
        if (!result.includes('id=')) {
          result += (result.includes('?') ? '&' : '?') + `id=${variantId}`;
        }
        if (!result.includes('quantity=')) {
          result += `&quantity=${quantity}`;
        }
        return result;
      }
    }
    
    const fallbackFormData = new FormData();
    fallbackFormData.append('id', variantId);
    fallbackFormData.append('quantity', quantity);
    return fallbackFormData;
  }
  
  function createRequestSignature(data) {
    const userQty = getQuantityFromData(data);
    const timestamp = Date.now();
    const baseSignature = `qty-${userQty}-time-${Math.floor(timestamp / 5000)}`;
    return baseSignature;
  }
  
  function getQuantityFromData(data) {
    if (!data) return 1;
    
    let quantity = 1;
    
    try {
      if (data instanceof FormData) {
        quantity = parseInt(data.get('quantity')) || 1;
      } else if (typeof data === 'string') {
        try {
          const json = JSON.parse(data);
          quantity = parseInt(json.quantity) || 1;
        } catch (e) {
          const match = data.match(/quantity=(\d+)/);
          quantity = match ? parseInt(match[1]) : 1;
        }
      }
    } catch (e) {
      quantity = 1;
    }
    
    quantity = Math.max(1, Math.floor(Math.abs(quantity)));
    return quantity;
  }

  // ✅ YENİ: Request body'den variant ID'sini çıkar
  function getVariantIdFromData(data) {
    if (!data) return null;

    try {
      if (data instanceof FormData) {
        const id = data.get('id');
        if (id) return String(id);
      } else if (typeof data === 'string') {
        try {
          const json = JSON.parse(data);
          if (json.id) return String(json.id);
        } catch (e) {
          const match = data.match(/id=(\d+)/);
          if (match) return match[1];
        }
      }
    } catch (e) {
      log('Error extracting variant ID from data:', e);
    }

    return null;
  }

  function triggerCartEvents(cart) {
    const cartUpdateEvent = new CustomEvent('cart:updated', {
      detail: { cart }
    });
    document.dispatchEvent(cartUpdateEvent);

    const events = [
      'cart:update',
      'cart:refresh', 
      'cartUpdated',
      'cart-updated',
      'ajaxCart:update'
    ];

    events.forEach(eventName => {
      const event = new CustomEvent(eventName, {
        detail: { cart, itemCount: cart.item_count }
      });
      document.dispatchEvent(event);
    });

    if (window.jQuery) {
      window.jQuery(document).trigger('cart:updated', [cart]);
      window.jQuery(document).trigger('cartUpdated', [cart]);
    }
  }

  function updateCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }

    if (window.theme && window.theme.cartDrawer) {
      try {
        window.theme.cartDrawer.refresh();
      } catch (e) {
        log('Theme cart drawer refresh error:', e.message);
      }
    }
  }
  
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCounters = document.querySelectorAll(
          '.cart-count, [data-cart-count], .cart-item-count, #cart-icon-bubble, .cart-counter'
        );
        cartCounters.forEach(counter => {
          counter.textContent = cart.item_count;
          counter.setAttribute('data-cart-count', cart.item_count);
        });
        
        triggerCartEvents(cart);
        updateCartDrawer();
        
        log('Cart updated:', cart.item_count);
      })
      .catch(error => {
        logError('Cart update error:', error);
      });
  }
  
  forceMultiplier();
  
})();